import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { PrimaryButton } from "../../components/PrimaryButton";
import { Header } from "../../components/Header";
import { Container } from "./styles";
import { Sidebar } from "../../components/SideBar";
import { AccessibilityPopup } from "../../components/AccessibilityPopup";

export function Tutorial() {
  const [videoUrl, setVideoUrl] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storageVideoUrl = "./tutorial.mp4";

    if (storageVideoUrl) setVideoUrl(storageVideoUrl);
  }, []);

  return (
    <Container>
      <Header
        scenarioName={undefined}
        onBack={() => { }}
        onImportClick={() => { }}
        headerPage={0}
        onEvalClick={() => { }}
        toggleSidebar={() => setShowSidebar(!showSidebar)}
        showSidebar={showSidebar}
        isAccessibilityOpen={isAccessibilityOpen}
        setIsAccessibilityOpen={setIsAccessibilityOpen}
        backToHome={()=>navigate("/home")}
        Aimode={false}
        closeAimode={()=>{}}
      />
      <Sidebar
        open={showSidebar}
        onClose={() => setShowSidebar(false)}
      />
      <AccessibilityPopup isOpen={isAccessibilityOpen} onClose={() => setIsAccessibilityOpen(false)} />

      <div className="content">
        <div className="videoContainer">
          <div className="video">
            {videoUrl ? <video src={videoUrl} controls controlsList="nodownload" /> : null}
          </div>
          <div className="buttonContainer">
            <Link to="/home" style={{ textDecoration: "none" }}>
              <PrimaryButton className="jumpButton">
                <span>AVANÇAR</span>
                <span className="material-icons-outlined">redo</span>
              </PrimaryButton>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
}
